<div class="footer">
    <div class="copyright">&copy; Advantage Golf GPS Technology</div>
</div>